function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function closePopup(cname, cvalue, exdays) {
    $('#popup').removeClass('active');
    setCookie(cname, cvalue, exdays);
}

jQuery(document).ready(function() {

    //fix loadig js lag
    jQuery('.no-js').removeClass("no-js");

    $('.slider-for').slick({
        autoplay: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        fade: true,
        autoplaySpeed: 2000,
        speed: 1000
            //asNavFor: '.slider-nasv'
    });


    $('.slide-nav[data-slide]').click(function(e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        $('.slider-for').slick('slickGoTo', slideno);
    });



    jQuery('.fullscreen-slide').slick({
        autoplay: true,
        dots: true,
        adaptiveHeight: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplaySpeed: 4000,
        speed: 4000,
        fade: true
    });

    //big carousel
    jQuery('.side-carousel').slick({
        autoplay: true,
        dots: true,
        adaptiveHeight: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplaySpeed: 2000,
        speed: 1000
    });


    $('.el-carousel-6').slick({
        autoplay: true,
        dots: true,
        infinite: true,
        slidesToScroll: 3,
        slidesToShow: 6,
        //centerMode: true,
        autoplaySpeed: 1000,
        speed: 1000,

        responsive: [

            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]

    });

    $('.el-carousel-7').slick({
        autoplay: true,
        dots: true,
        infinite: true,
        slidesToScroll: 3,
        slidesToShow: 4,
        //centerMode: true,
        autoplaySpeed: 1000,
        speed: 1000,

        responsive: [

            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]

    });


    if (jQuery("#my-svg").length != 0) {
        //it doesn't exist


        new Vivus('my-svg', {
            duration: 200,
            start: 'autostart',
            onReady: function() {
                jQuery('.vivus-notready').removeClass("vivus-notready");
            },
            animTimingFunction: Vivus.EASE
        });

    }


    if (jQuery("#svg2").length != 0) {
        new Vivus('svg2', {
            duration: 400,
            start: 'autostart',
            attr: {
                width: '100%',
                height: '100%',
                preserveAspectRatio: "none"
            },
            onReady: function() {
                jQuery('.vivus-notready').removeClass("vivus-notready");
            },
            animTimingFunction: Vivus.EASE
        });

    }



});





/* Validation Events for changing response CSS classes */
document.addEventListener('wpcf7invalid', function(event) {
    $('.wpcf7-response-output').addClass('alert alert-danger');
}, false);
document.addEventListener('wpcf7spam', function(event) {
    $('.wpcf7-response-output').addClass('alert alert-warning');
}, false);
document.addEventListener('wpcf7mailfailed', function(event) {
    $('.wpcf7-response-output').addClass('alert alert-warning');
}, false);
document.addEventListener('wpcf7mailsent', function(event) {
    $('.wpcf7-response-output').addClass('alert alert-success');
}, false);
document.addEventListener('wpcf7invalid', function(event) {
    $('.wpcf7-not-valid-tip').addClass('field-required');
}, false);



/* Cookiebar */
jQuery(document).ready(function(){
    jQuery.cookieBar({
      message: 'Per offrirti una migliore esperienza questo sito utilizza cookie di profilazione, anche di terze parti. Chiudendo questo banner o cliccando qualsiasi elemento acconsenti all\'utilizzo dei cookie. Per saperne di più consulta la nostra Privacy Policy</a>',
      acceptButton: true,
      acceptText: 'Ok',
      acceptFunction: null,
      declineButton: false,
      declineText: 'Disable Cookies',
      declineFunction: null,
      policyButton: true,
      policyText: 'Privacy Policy',
      policyURL: '/privacy-policy/',
      autoEnable: true,
      acceptOnContinue: false,
      acceptOnScroll: false,
      acceptAnyClick: true,
      expireDays: 365,
      renewOnVisit: false,
      forceShow: false,
      element: 'body',
      append: false,
      fixed: true,
      bottom: true,
      zindex: '9999',
      effect: 'fade',
      domain: 'mazzatoassociati.com',
      referrer: 'mazzatoassociati.com'
    });
  });
